import OrbitEight from '../components/OrbitEight';
import OrbitFive from '../components/OrbitFive';
import OrbitFour from '../components/OrbitFour';
import OrbitOne from '../components/OrbitOne';
import OrbitSeven from '../components/OrbitSeven';
import OrbitSix from '../components/OrbitSix';
import OrbitThree from '../components/OrbitThree';
import OrbitTwo from '../components/OrbitTwo';

export const ORBITS = [
  {
    id: 1,
    src: OrbitOne,
  },
  {
    id: 2,
    src: OrbitTwo,
  },
  {
    id: 3,
    src: OrbitThree,
  },
  {
    id: 4,
    src: OrbitFour,
  },
  {
    id: 5,
    src: OrbitFive,
  },
  {
    id: 6,
    src: OrbitSix,
  },
  {
    id: 7,
    src: OrbitSeven,
  },
  {
    id: 8,
    src: OrbitEight,
  },
];
